<template>
  <div class="user">
     <el-form-item label="开启广告位申请">
        <div>
          <el-radio v-model="form.is_open" :label="1">开</el-radio>
          <el-radio v-model="form.is_open" :label="0">关</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="广告是否需要审核">
        <div>
          <el-radio v-model="form.need_check" :label="1">是</el-radio>
          <el-radio v-model="form.need_check" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="联盟币支付开启">
        <div>
          <el-radio v-model="form.price_pay" :label="1">是</el-radio>
          <el-radio v-model="form.price_pay" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="积分支付开启">
        <div>
          <el-radio v-model="form.points_pay" :label="1">是</el-radio>
          <el-radio v-model="form.points_pay" :label="0">否</el-radio>
        </div>
      </el-form-item>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
// import AdvApi from '@/api/adv.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,
  },
  
  data() {
    return {
       /*是否上传图片*/
      isupload: false,
      
    };
  },
  props: {
    form: Object,
    options: Array
  },
  methods: {
    // 上传
     openUpload(e) {
      this.isupload = true;
      this.uploadtype= e;
    },
      /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if(this.uploadtype==0){
          this.form.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }else{
          this.form.banner_file_path = e[0].file_path;
           this.form.banner_image_id = e[0].file_id;
        }
        
      }
      this.isupload = false;
    },
  }
  
};
</script>

<style>
.ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
 .ad-picture:hover {
  border: 1px dashed $blue;
}

 .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/adv/setting/part/Basic.vue